var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grades } from '@hn-front/data-types';
import { styled } from 'styled-components';
import { Title } from '../../Common';
import { grid } from './Common';
import { Item } from './Item';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-sienkf" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  border-top: 1px solid ", ";\n  padding: 16px 0 24px;\n"], ["\n  display: flex;\n  flex-flow: column;\n  border-top: 1px solid ", ";\n  padding: 16px 0 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black80;
});
var Header = styled.div.withConfig({ displayName: "Header", componentId: "sc-150dm2h" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  padding: 16px 16px 8px;\n  margin-top: 24px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 16px 16px -16px;\n  background: ", ";\n  margin-bottom: 16px;\n"], ["\n  ", "\n  padding: 16px 16px 8px;\n  margin-top: 24px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 16px 16px -16px;\n  background: ", ";\n  margin-bottom: 16px;\n"])), grid, function (_a) {
    var theme = _a.theme;
    return theme.colors.black100;
});
var Th = styled.span.withConfig({ displayName: "Th", componentId: "sc-1tze6c2" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: inherit;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"], ["\n  font-family: inherit;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n"])));
var LeaderBoard = function (_a) {
    var data = _a.data, rest = __rest(_a, ["data"]);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(Title, { children: "Leaderboard" }, void 0), _jsxs(Header, { children: [_jsx(Th, { children: "rank" }, void 0), _jsx(Th, { children: "class" }, void 0), _jsx(Th, { children: "teacher" }, void 0), _jsx(Th, { children: "total points" }, void 0), _jsx(Th, {}, void 0)] }, void 0), data.map(function (_a) {
                var position = _a.position, rank = _a.rank, gradeValue = _a.gradeValue, groupNumber = _a.groupNumber, teacherEmail = _a.teacherEmail, totalPoints = _a.totalPoints, own = _a.own, weeks = _a.weeks;
                var className = Grades[gradeValue].full + " | " + groupNumber;
                return (_jsx(Item, { rank: rank, className: className, teacherEmail: teacherEmail, points: totalPoints, selected: own, weeks: weeks }, position));
            })] }), void 0));
};
export { LeaderBoard };
var templateObject_1, templateObject_2, templateObject_3;
